import { useEffect, useRef, useState } from "react";
import { ModalProps } from "./modal.props";
import closeSvg from "src/assets/static/img/main/close.svg";

export const Modal: React.FC<ModalProps> = ({ children, onClose, onShow, show, title, className, lg, renderFooter }) => {

    const [open, setOpen] = useState(false);
    const modalRef = useRef<HTMLDivElement>(null);

    const close = () => {
        if (onClose) onClose();
    };

    const style = show ? {} : { display: "none" };

    useEffect(() => {

        if (show !== open)
            setTimeout(() => {
                setOpen(show || false);
            }, 100);

        if (show && onShow) {
            onShow();
        }

        if (show) {
            document.getElementsByTagName("body")[0].classList.add("modal-open");
        }
        else {
            document.getElementsByTagName("body")[0].classList.remove("modal-open");
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);


    useEffect(() => {

        const handelClickAnywhere = (e: MouseEvent) => {


            if (!show) return;

            if (!modalRef || !modalRef.current) return;

            if (modalRef.current.contains(e.target as Node)) return;

            close();
        };

        document.addEventListener("click", handelClickAnywhere);

        return (() => {
            document.removeEventListener("click", handelClickAnywhere);
        });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [show]);

    return (
        <div className={`modal-component ${className || ""}`}>
            <div className={`modal fade${show ? " d-block" : ""}${open ? " show" : ""}`} style={style}>
                <div className={`modal-dialog ${lg ? "modal-lg modal-dialog-centered" : "modal-md"}`} ref={modalRef}>
                    <div className="modal-content">
                        <header className="modal-header">
                            <div slot="modal-header" className="w-100 text-center" >
                                <span>{title}</span>
                                <div slot="modal-header-close" className="float-left cursor-pointer close-modal">
                                    <img alt="close" src={closeSvg} onClick={close} />
                                </div>
                            </div>
                        </header>
                        <div className="modal-body">
                            {children}
                        </div>
                        <footer className="modal-footer">
                            <div className="w-100">
                                <div className="row align-items-center">
                                    {renderFooter && renderFooter()}
                                </div>
                            </div>
                        </footer>
                    </div>
                </div>
            </div>
            <div className={`modal-backdrop fade${open ? " show" : ""}`} style={style} />
        </div>
    );

};